import { useSelectedGroup } from "./context";
import { getGroupIdBySelectedGroup } from "./utils";

export function useSelectedGroupId() {
  const { selectedGroup } = useSelectedGroup();

  return getGroupIdBySelectedGroup(selectedGroup);
}
